import { Button } from '@instructure/ui-buttons'
import { Flex } from '@instructure/ui-flex'
import { FormFieldGroup } from '@instructure/ui-form-field'
import { Link } from '@instructure/ui-link'
import { Spinner } from '@instructure/ui-spinner'
import { Text } from '@instructure/ui-text'
import { ValidatingTextInput } from '../../../../mc-ui/elements/Html5ValidatingTextInput'
import { View } from '@instructure/ui-view'
import { ScreenReaderContent } from '@instructure/ui-a11y-content'

const FORGOT_PASSWORD_URL = '/forgot_password'
const SAML_CALLBACK_URL = '/auth/saml/callback'

export const Form = ({
  credentials: { login, password },
  attempting,
  onCredentialsChange,
  onSubmit,
  samlRequest,
  relayState
}) => {
  const interactionMode = () => attempting ? 'disabled' : 'enabled'

  return (
    <View as="div" margin="large none">
      <form action={SAML_CALLBACK_URL} method="post" onSubmit={ (e) => { onSubmit(e) } } noValidate>
        <input type="hidden" name="SAMLRequest" value={samlRequest} />
        <input type="hidden" name="RelayState" value={relayState} />

        <FormFieldGroup description={<ScreenReaderContent>Login form fields</ScreenReaderContent>} layout="stacked" rowSpacing="medium">
          <ValidatingTextInput
            name="login"
            type="email"
            renderLabel={
              <Text color="primary-inverse">
                Email Address
              </Text>
            }
            value={login}
            isRequired={true}
            onChange={(_evt, value) => onCredentialsChange({ login: value, password })}
            interaction={interactionMode()}
          />

          <ValidatingTextInput
            name="password"
            type="password"
            renderLabel={
              <Text color="primary-inverse">Password</Text>
            }
            value={password}
            isRequired={true}
            onChange={(_evt, value) => onCredentialsChange({ login, password: value})}
            interaction={interactionMode()}
          />

          <Flex>
            <Flex.Item padding="x-small" margin="none large none none">
              <Link href={FORGOT_PASSWORD_URL} color="link-inverse">
                Forgot Password?
              </Link>
            </Flex.Item>

            <Flex.Item shouldGrow textAlign="end" margin="none none none large">
              <Button
                type="submit"
                display="block"
                textAlign="center"
                color="primary-inverse"
                withBackground={false}
                interaction={interactionMode()}
              >
                {attempting &&
                  <Spinner renderTitle="Checking..." size="x-small" variant="inverse" />
                }
                Log In
              </Button>
            </Flex.Item>
          </Flex>
        </FormFieldGroup>
      </form>
    </View>
  )
}
